import EmptyView1 from '../../layouts/EmptyView1'
import UnlockAccount from './UnlockAccount'

export default EmptyView1(UnlockAccount)



// WEBPACK FOOTER //
// ./src/pages/unlock-account/index.js